import { cn } from '@/shared/utils/cn';
import React from 'react';
import { ListItemUser } from '../molecules/ListItemUser';

export interface ListUserListItem {
  id: string;
  name: string;
  subtitle?: string;
  avatar?: React.ReactNode | string;
  badge?: string;
  badgeVariant?: 'success' | 'warning' | 'error' | 'info';
}

export interface ListUserListProps {
  users: ListUserListItem[];
  selectedUserId?: string;
  onUserClick?: (userId: string) => void;
  className?: string;
}

export const ListUserList: React.FC<ListUserListProps> = ({
  users,
  selectedUserId,
  onUserClick,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-shadow-03',
        'ui-flex ui-min-w-[320px] ui-flex-col ui-gap-8',
        className,
      )}
    >
      {users.map((user) => (
        <ListItemUser
          key={user.id}
          name={user.name}
          subtitle={user.subtitle}
          avatar={user.avatar}
          badge={user.badge}
          badgeVariant={user.badgeVariant}
          selected={selectedUserId === user.id}
          onClick={() => onUserClick?.(user.id)}
        />
      ))}
    </div>
  );
};
